<p-toast></p-toast>
<app-page-shell>
<app-page-hero eyebrow="POSM Executions" [title]="importSchedulesMode ? 'Import Delivery Schedules' : editingProjectId ? 'Edit POSM Execution' : 'New POSM Execution'" [subtitle]="importSchedulesMode ? 'Upload and review the delivery schedule for ' + (editingProject()?.projectNumber || 'this execution') + '. Existing schedules are kept.' : editingProjectId ? 'Update the execution header and its linked Logistics Project.' : 'Create the execution header first; strategy, stores, schedule imports, tasks, and incidents are managed from the POSM execution workspace. Logistics Project context is created and linked automatically.'">
        <div actions>
            <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="cancel()"></p-button>
            <p-button [label]="importSchedulesMode ? 'Import Schedules' : editingProjectId ? 'Save Changes' : 'Create Execution'" icon="pi pi-check"
                [disabled]="isParsing() || (!!editingProjectId && !editingProjectLoaded()) || (importSchedulesMode && !deliveryScheduleRows().length)" [loading]="isSaving()" (click)="createProject()"></p-button>
        </div>
    </app-page-hero>

    <form class="overFlow" [formGroup]="createProjectForm" novalidate autocomplete="off" autocorrect="off"
        autocapitalize="off" spellcheck="off">
        <div class="p-fluid flex flex-column gap-3">
            @if (!importSchedulesMode) {
                <app-page-form-section icon="pi pi-briefcase" title="Execution Information" [subtitle]="editingProjectId ? 'Update priority, dates, and KAM. Execution identity and job scope are fixed after creation.' : 'Client, account, execution ownership, and job classification.'">
                    <div class="formgrid grid">
                        @if (dropdownValuesLoading()) {
                            <div class="col-12">
                                <div class="dropdown-loading-state">
                                    <i class="pi pi-spin pi-spinner"></i>
                                    <span>Loading dropdown values...</span>
                                </div>
                            </div>
                        }
                        @if (editingProjectId) {
                            @if (editingProject(); as project) {
                                <div class="col-12">
                                    <div class="surface-50 border-round p-3">
                                        <div class="font-semibold mb-2">Fixed execution details</div>
                                        <div class="grid">
                                            <div class="col-12 md:col-4"><small>Execution Name</small><div>{{ project.projectName || '-' }}</div></div>
                                            <div class="col-12 md:col-4"><small>CRM Client</small><div>{{ project.crmClient?.companyName || '-' }}</div></div>
                                            <div class="col-12 md:col-4"><small>CRM Account</small><div>{{ project.clientAccountName || '-' }}</div></div>
                                            <div class="col-12 md:col-4"><small>CRM Contact</small><div>{{ project.clientContactName || '-' }}</div></div>
                                            <div class="col-12 md:col-4"><small>Job Type Group</small><div>{{ project.jobTypeGroup || '-' }}</div></div>
                                            <div class="col-12 md:col-4"><small>Job Types</small><div>{{ project.jobTypes?.join(' + ') || project.jobType || '-' }}</div></div>
                                        </div>
                                    </div>
                                </div>
                            }
                        } @else {
                        <div class="field col-12 md:col-4 l:col-3">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="fa-solid fa-briefcase"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <input formControlName="projectName" id="projectName" type="text" pInputText />
                                    <label for="projectName">Execution Name</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        <div class="field col-12">
                            <app-commercial-party-picker
                                [owningCompanyId]="owningCompanyId() || undefined" [value]="commercialPartyReference" [required]="true"
                                [allowLegacy]="false" [requireCrmAccount]="true"
                                label="POSM Commercial Party"
                                (quickCreated)="onCrmQuickCreated($event)"
                                (valueChange)="onCommercialPartyChange($event)">
                            </app-commercial-party-picker>
                        </div>
                        <div class="field col-12 md:col-4 l:col-3">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="fa-solid fa-list-check"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-select formControlName="jobTypeGroup" id="jobTypeGroup" [options]="jobTypeGroupOptions()"
                                        optionLabel="label" optionValue="value" styleClass="w-full"
                                        [loading]="isMasterDataLoading()"></p-select>
                                    <label for="jobTypeGroup">Job Type Group</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        <div class="field col-12 md:col-4 l:col-3">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="fa-solid fa-list-check"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-multiSelect formControlName="jobTypeIds" id="jobTypeIds" [options]="filteredJobTypeOptions()"
                                        optionLabel="name" optionValue="id" [filter]="true" [showToggleAll]="false"
                                        display="chip" styleClass="w-full" [loading]="isMasterDataLoading()"></p-multiSelect>
                                    <label for="jobTypeIds">Job Types</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        }
                        <div class="field col-12 md:col-4 l:col-3">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="fa-solid fa-flag"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-selectButton [options]="priorityOptions()" formControlName="jobPriority" style="width: 100%;"
                                        optionLabel="label" optionValue="value" styleClass="w-full"></p-selectButton>
                                    <label>Job Priority</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        
                        <div class="field col-12 md:col-4 l:col-3">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="fa-solid fa-calendar-day"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-datePicker formControlName="startDate" id="startDate" appendTo="body"
                                        dateFormat="dd/mm/yy" styleClass="w-full"></p-datePicker>
                                    <label for="startDate">Start Date</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        <div class="field col-12 md:col-4 l:col-3">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="fa-solid fa-calendar-check"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-datePicker formControlName="deadline" id="deadline" appendTo="body"
                                        dateFormat="dd/mm/yy" styleClass="w-full"></p-datePicker>
                                    <label for="deadline">Deadline</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                        <div class="field col-12 md:col-4 l:col-3">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="fa-solid fa-user-tie"></i></p-inputGroupAddon>
                                <p-iftaLabel>
                                    <p-select formControlName="manager" id="manager" [options]="managerOptions()"
                                        optionLabel="name" [showClear]="true" styleClass="w-full"></p-select>
                                    <label for="manager">KAM</label>
                                </p-iftaLabel>
                            </p-inputGroup>
                        </div>
                    </div>
                </app-page-form-section>
            }

            @if (!editingProjectId || importSchedulesMode) {
            <!-- Delivery Schedule Upload Fieldset -->
                <app-page-form-section icon="pi pi-file-excel" title="Delivery Schedule Upload" subtitle="Download or upload the execution delivery schedule; stores are created as LogiLink locations and stands/materials stay in Warehousing.">
                    <div class="formgrid grid">
                        <div class="field col-12">
                            <div class="flex justify-content-between align-items-center mb-3">
                                <span class="text-sm text-500">Use the current template. Located Warehouse is required after U Code; enter the code shown in Warehousing &gt; Warehouses.</span>
                                <div class="flex align-items-center gap-2">
                                    <p-button
                                        label="Clear Upload"
                                        icon="pi pi-trash"
                                        severity="secondary"
                                        [text]="true"
                                        [disabled]="!uploadedStores().length && !deliveryScheduleRows().length"
                                        (click)="clearUploadedSchedule(deliveryScheduleUpload)">
                                    </p-button>
                                    <p-button label="Download Template" icon="pi pi-download" styleClass="p-button-text" (click)="downloadTemplate()"></p-button>
                                </div>
                            </div>
                            
                            <p-fileUpload #deliveryScheduleUpload name="deliverySchedule" [customUpload]="true" (uploadHandler)="onUploadStoreList($event)"
                                accept=".xlsx" [auto]="true" chooseLabel="Upload Delivery Schedule"
                                [disabled]="isParsing()"
                                styleClass="w-full">
                                <ng-template #content>
                                    <div class="flex align-items-center justify-content-center flex-column p-5 border-2 border-dashed border-300 surface-50 border-round pointer-events-none">
                                        <i class="pi pi-cloud-upload text-blue-500 text-4xl mb-3"></i>
                                        <p class="m-0 font-medium">Drag and drop delivery schedule Excel file here</p>
                                    </div>
                                </ng-template>
                            </p-fileUpload>

                            @if (uploadedStores().length) {
                                <div class="mt-4">
                                    <div class="flex align-items-center justify-content-between mb-2">
                                        <div>
                                            <div class="font-bold text-900">LogiLink Location Preview</div>
                                            <div class="text-sm text-500">Each unique store will be created or linked as a LogiLink Location.</div>
                                        </div>
                                        <div class="flex align-items-center gap-2">
                                            <p-tag [value]="uploadedStores().length + ' locations'" severity="info"></p-tag>
                                            <p-tag [value]="deliveryScheduleRows().length + ' schedule rows'" severity="secondary"></p-tag>
                                        </div>
                                    </div>
                                    <p-table [value]="uploadedStores()" [paginator]="uploadedStores().length > 8" [rows]="8"
                                        styleClass="p-datatable-sm no-borders">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>Store Location</th>
                                                <th>City</th>
                                                <th>Company & Contact</th>
                                                <th>Location Match</th>
                                                <th>Item Number</th>
                                                <th>Item Name</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-store let-i="rowIndex">
                                            <tr>
                                                <td>
                                                    <div class="font-semibold text-900">{{ storeLocationLabel(store) }}</div>
                                                    <div class="text-xs text-500 mt-1">Type: POSM_STORE | Ref: {{ storeLocationReference(store) }}</div>
                                                </td>
                                                <td>
                                                    <div>{{ store.city || '-' }}</div>
                                                </td>
                                                <td>
                                                    <div>{{ store.contactPersonName || '-' }}</div>
                                                    <div class="text-xs text-500 mt-1">{{ store.contactPersonPhone || 'No phone' }}</div>
                                                </td>
                                                <td>
                                                    @if (locationMatches()[i]; as match) {
                                                        <p-select [options]="locationOptions(match)" optionLabel="label" optionValue="value"
                                                            [ngModel]="store.locationMatchAction === 'CREATE' ? -1 : store.location?.id"
                                                            [ngModelOptions]="{standalone: true}" (ngModelChange)="chooseLocation(store, $event)"
                                                            placeholder="Choose a location" appendTo="body" styleClass="w-full"
                                                            [attr.aria-label]="'Location match for ' + storeLocationLabel(store)"></p-select>
                                                        <input pInputText #locationSearch type="text"
                                                            [attr.aria-label]="'Search other locations for ' + storeLocationLabel(store)"
                                                            placeholder="Search other locations" (keyup.enter)="searchAdditionalLocations(i, locationSearch.value); $event.preventDefault()">
                                                        @if (match.requiresReview && !store.locationMatchAction) {
                                                            <small class="text-orange-600">Review the suggested locations.</small>
                                                        }
                                                    } @else {
                                                        <span>Checking locations…</span>
                                                    }
                                                </td>
                                                <td>{{ storeItemNumbers(store) }}</td>
                                                <td>{{ storeItemNames(store) }}</td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            }
                        </div>
                    </div>
                </app-page-form-section>

            <!-- Stands & Material Details -->
                <app-page-form-section icon="pi pi-box" title="Stands and Material Details" subtitle="Select warehousing item first, then brand, source warehouse, and quantity from the client-linked Warehousing catalog.">
                    <div class="formgrid grid">
                        @if (isMasterDataLoading()) {
                            <div class="col-12">
                                <div class="dropdown-loading-state">
                                    <i class="pi pi-spin pi-spinner"></i>
                                    <span>Loading warehousing dropdown values...</span>
                                </div>
                            </div>
                        }
                        <div class="col-12 flex justify-content-end gap-2 mb-2">
                            <p-button label="New Warehousing Item" icon="fa-solid fa-box-open" severity="secondary"
                                [outlined]="true" (click)="openWarehousingItemCreate()"></p-button>
                            <p-button label="New Warehouse" icon="fa-solid fa-warehouse" severity="secondary"
                                [outlined]="true" (click)="openWarehousingWarehouseCreate()"></p-button>
                        </div>
                        <div class="col-12 flex flex-column gap-3">                            @for (item of projectItems(); track i; let i = $index) {
                                <div class="border-1 border-200 border-round p-4 surface-50 mb-3">
                                    <div class="flex justify-content-end mb-2">
                                        @if (projectItems().length > 1 && !item.importGroupKey) {
                                            <p-button icon="fa-solid fa-xmark"
                                                styleClass="p-button-text p-button-danger p-button-rounded"
                                                (click)="removeStandItem(i)"></p-button>
                                        }
                                    </div>
                                    <div class="grid mt-2">
                                        <div class="col-12 lg:col-8">
                                            <div class="field">
                                                    <p-inputGroup>
                                                    <p-inputGroupAddon><i class="fa-solid fa-box"></i></p-inputGroupAddon>
                                                    <p-iftaLabel>
                                                        <p-select [options]="itemOptionsForBrand(item)"
                                                            [(ngModel)]="item.inventoryItem"
                                                            (ngModelChange)="onWarehousingItemChanged(item)"
                                                            [disabled]="!!item.importGroupKey"
                                                            [ngModelOptions]="{standalone: true}" optionLabel="displayName"
                                                            [filter]="true"
                                                            filterBy="displayName,itemMeta,sizeLabel,itemName,skuNumber,itemNumber,customerItemNumber"
                                                            [showClear]="true" appendTo="body" styleClass="w-full"
                                                            [loading]="isMasterDataLoading()">
                                                            <ng-template #selectedItem let-selectedItem>
                                                                @if (selectedItem) {
                                                                    <span>{{ selectedItem.itemName }} | {{ selectedItem.sizeLabel }}</span>
                                                                }
                                                            </ng-template>
                                                            <ng-template #item let-option>
                                                                <div class="flex flex-column gap-1">
                                                                    <span class="font-semibold">{{ option.itemName }}</span>
                                                                    <span class="text-sm text-500">{{ option.itemMeta }}</span>
                                                                    <span class="text-sm text-600">Size: {{ option.sizeLabel }}</span>
                                                                </div>
                                                            </ng-template>
                                                        </p-select>
                                                        <label>Warehousing Items</label>
                                                    </p-iftaLabel>
                                                    <p-inputGroupAddon>
                                                        <p-button icon="fa-solid fa-plus" styleClass="p-button-text"
                                                            title="Create Warehousing item"
                                                            [disabled]="!!item.importGroupKey"
                                                            (click)="openWarehousingItemCreate(item)"></p-button>
                                                    </p-inputGroupAddon>
                                                </p-inputGroup>
                                                @if (item.importGroupKey) {
                                                    <small class="text-500">The imported U Code determines this item. Change the code in Excel to select another item.</small>
                                                }
                                                @if (item.inventoryItem?.id) {
                                                    <div class="surface-100 border-round p-2 mt-2 text-sm">
                                                        <div class="grid">
                                                            <div class="col-12 md:col-4">
                                                                <span class="text-500">Item #</span>
                                                                <div class="font-semibold">{{ item.inventoryItem?.itemNumber || item.inventoryItem?.skuNumber || item.inventoryItem?.customerItemNumber || '-' }}</div>
                                                            </div>
                                                            <div class="col-12 md:col-4">
                                                                <span class="text-500">Client</span>
                                                                <div class="font-semibold">{{ warehousingClientName(item.inventoryItem?.crmClientId) }}</div>
                                                            </div>
                                                            <div class="col-12 md:col-4">
                                                                <span class="text-500">Account</span>
                                                                <div class="font-semibold">{{ warehousingAccountName(item.inventoryItem?.crmAccountId) }}</div>
                                                            </div>
                                                            <div class="col-12 md:col-4">
                                                                <span class="text-500">Customer Reference</span>
                                                                <div class="font-semibold">{{ item.inventoryItem?.customerItemNumber || '-' }}</div>
                                                            </div>
                                                            <div class="col-12 md:col-4">
                                                                <span class="text-500">SKU</span>
                                                                <div class="font-semibold">{{ item.inventoryItem?.skuNumber || '-' }}</div>
                                                            </div>
                                                            <div class="col-12 md:col-4">
                                                                <span class="text-500">Size</span>
                                                                <div class="font-semibold">{{ warehousingItemSizeLabel(item.inventoryItem) }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                @if (item.missingItemReference) {
                                                    <small class="text-orange-600">Not found in Warehousing: {{ item.missingItemReference }}</small>
                                                } @else if (!item.brandId) {
                                                    <small class="text-500">Select a brand to narrow the client-linked item list.</small>
                                                }
                                            </div>
                                        </div>
                                        <div class="col-12 lg:col-4">
                                            <div class="field">
                                                    <p-inputGroup>
                                                    <p-inputGroupAddon><i class="fa-solid fa-tag"></i></p-inputGroupAddon>
                                                    <p-iftaLabel>
                                                        <p-select [options]="brandOptionsForItem(item)"
                                                            [(ngModel)]="item.brandId"
                                                            (ngModelChange)="onBrandChanged(item)"
                                                            [disabled]="!!item.importGroupKey"
                                                            [ngModelOptions]="{standalone: true}" optionLabel="name"
                                                            optionValue="id" [filter]="true" [showClear]="true"
                                                            appendTo="body" styleClass="w-full"
                                                            [loading]="isMasterDataLoading()"></p-select>
                                                        <label>Brand</label>
                                                    </p-iftaLabel>
                                                </p-inputGroup>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid mt-3">
                                        <div class="col-12 lg:col-8">
                                            <div class="field">
                                                    <p-inputGroup>
                                                    <p-inputGroupAddon><i class="fa-solid fa-warehouse"></i></p-inputGroupAddon>
                                                    <p-iftaLabel>
                                                        <p-select [options]="warehouseOptions()"
                                                            [(ngModel)]="item.sourceWarehouse"
                                                            (ngModelChange)="onSourceWarehouseChanged(item)"
                                                            [ngModelOptions]="{standalone: true}" optionLabel="name"
                                                            dataKey="warehousingWarehouseId"
                                                            [filter]="true" filterBy="name,shortDescription,externalLocationReference"
                                                            [showClear]="true" appendTo="body" styleClass="w-full"
                                                            [loading]="isMasterDataLoading()"></p-select>
                                                        <label>Source Warehouse</label>
                                                    </p-iftaLabel>
                                                    <p-inputGroupAddon>
                                                        <p-button icon="fa-solid fa-plus" styleClass="p-button-text"
                                                            title="Create warehouse"
                                                            (click)="openWarehousingWarehouseCreate(item)"></p-button>
                                                    </p-inputGroupAddon>
                                                </p-inputGroup>
                                                @if (item.importGroupKey) {
                                                    <small class="text-500">Imported code: {{ item.sourceWarehouse?.code || 'Select a coded warehouse' }}. Changing this warehouse updates its delivery rows.</small>
                                                }
                                            </div>
                                        </div>
                                        <div class="field col-12 lg:col-4">
                                            <p-inputGroup>
                                                <p-inputGroupAddon><i class="fa-solid fa-cubes"></i></p-inputGroupAddon>
                                                <p-iftaLabel>
                                                    <p-inputNumber [(ngModel)]="item.quantity"
                                                        [ngModelOptions]="{standalone: true}" [showButtons]="true" [min]="1"
                                                        [disabled]="!!item.importGroupKey"
                                                        styleClass="w-full"></p-inputNumber>
                                                    <label>Quantity</label>
                                                </p-iftaLabel>
                                            </p-inputGroup>
                                            <div class="mt-2">
                                                <p-tag [value]="itemAvailability(item).text"
                                                    [severity]="itemAvailability(item).severity"></p-tag>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }


                            @if (!importSchedulesMode) {
                            <p-button label="Add Item Requirement" icon="fa-solid fa-plus"
                                styleClass="p-button-text p-button-primary mt-2 flex align-self-start"
                                (click)="addNewStandItem()"></p-button>
                            }
                        </div>
                    </div>
                </app-page-form-section>
            }

        </div>
    </form>
</app-page-shell>
